import get from "lodash/get";
import { DateTime } from "luxon";
import logger from "@/utils/logger";
import constants from "@/utils/constants";

export const getReadingTimeString = (reading) => {
  let timeText;
  let formatDate;
  let fullCardDate;

  const timestamp = get(reading, "ts", null);
  const timeZone = { zone: "UTC", setZone: true };

  if (!timestamp) return null;

  logger.info("localtime", DateTime.fromSQL(timestamp, timeZone).toLocal());
  timeText = DateTime.fromSQL(timestamp, timeZone)
    .toLocal()
    .startOf("day")
    .toRelative({
      unit: "days",
      base: DateTime.now().toLocal().startOf("day"),
    });
  formatDate = DateTime.fromSQL(timestamp, timeZone)
    .toLocal()
    .toFormat("h:mma");

  // format date to have h:mma, weekday, month/day/year
  fullCardDate = DateTime.fromSQL(timestamp, timeZone)
    .toLocal()
    .toFormat("cccc h:mma,  M/d");

  if (timeText === constants.DAYS.ZERO_DAYS_AGO) {
    timeText = `Today ${formatDate}`;
  } else if (timeText === constants.DAYS.ONE_DAY_AGO) {
    timeText = `Yesterday ${formatDate}`;
  } else {
    timeText = `${fullCardDate}`;
  }
  return timeText;
};

const toFixedNoRound = (value, fixed) =>
  ~~(Math.pow(10, fixed) * value) / Math.pow(10, fixed);

export const getReadingValueForDeviceType = (deviceType, reading) => {
  let value = null;

  if (deviceType === constants.DEVICE_TYPES.BP_CUFF) {
    const systolic = get(reading, "systolic", null);
    const diastolic = get(reading, "diastolic", null);

    if (systolic && diastolic) {
      value = `${parseFloat(systolic).toFixed(0)}/${parseFloat(
        diastolic
      ).toFixed(0)}`;
    }

    return value;
  } else if (deviceType === constants.DEVICE_TYPES.SCALE) {
    const weight = get(reading, "weight", null);
    value = toFixedNoRound(weight, 1);
    return value;
  } else if (deviceType === constants.DEVICE_TYPES.GLUCOMETER) {
    value = get(reading, "reading_mgdL", null);
  } else if (deviceType === constants.DEVICE_TYPES.PULSE_OXIMETER) {
    value = get(reading, "spo2", null);
  }

  if (value) {
    value = parseFloat(value).toFixed(0);
  }

  return value;
};

export const getPulseForDeviceType = (deviceType, reading) => {
  let pulse = null;

  if (
    ![
      constants.DEVICE_TYPES.PULSE_OXIMETER,
      constants.DEVICE_TYPES.BP_CUFF,
    ].includes(deviceType)
  ) {
    return pulse;
  }

  if (deviceType === constants.DEVICE_TYPES.PULSE_OXIMETER) {
    pulse = get(reading, "pulse_bpm", null);
  } else if (deviceType === constants.DEVICE_TYPES.BP_CUFF) {
    pulse = get(reading, "pulse", null);
  }

  if (pulse) {
    pulse = Math.trunc(pulse);
  }

  return pulse;
};

export const shouldUseConsumerApiLatestReading = (
  consumerApiLatestReading,
  dataApiLatestReading
) => {
  const timestampFromConsumer = get(consumerApiLatestReading, "ts", null);
  const timestampFromData = get(dataApiLatestReading, "ts", null);

  if (!timestampFromData) return true;
  if (!timestampFromConsumer) return false;

  const dateTimeData = DateTime.fromSQL(timestampFromData, { setZone: "UTC" });
  const dateTimeConsumer = DateTime.fromSQL(timestampFromConsumer, {
    setZone: "UTC",
  });

  logger.info(dateTimeData);
  logger.info(dateTimeConsumer);

  if (dateTimeConsumer > dateTimeData) return true;
  return false;
};
